import { z } from 'zod';
import { BOOKING_MAX_DURATION_MIN, BOOKING_MAX_GUESTS, BOOKING_MIN_DURATION_MIN, BOOKING_MIN_GUESTS, BOOKING_STATUSES, } from '../constants.js';
import { phoneSchema } from './user.js';
export const createBookingSchema = z.object({
    guestName: z.string().trim().min(2, 'Минимум 2 символа').max(80),
    phone: phoneSchema,
    date: z
        .string()
        .datetime({ offset: true })
        .refine((value) => new Date(value).getTime() > Date.now() - 60_000, 'Дата не может быть в прошлом'),
    durationMin: z.number().int().min(BOOKING_MIN_DURATION_MIN).max(BOOKING_MAX_DURATION_MIN),
    guestsCount: z.number().int().min(BOOKING_MIN_GUESTS).max(BOOKING_MAX_GUESTS),
    comment: z.string().trim().max(1000).optional(),
});
export const bookingDtoSchema = z.object({
    id: z.string(),
    guestName: z.string(),
    phone: z.string(),
    date: z.string(),
    durationMin: z.number().int(),
    guestsCount: z.number().int(),
    comment: z.string().nullable(),
    status: z.enum(BOOKING_STATUSES),
    createdAt: z.string(),
});
export const updateBookingStatusSchema = z.object({
    status: z.enum(BOOKING_STATUSES),
});
